// extracted by css-extract-rspack-plugin
export default {"mainContainer":"mainContainer-BmQnkD","innerContainer":"innerContainer-OiCo6_","title":"title-X66rVO","content":"content-Dq4RRc"};